import { render, staticRenderFns } from "./ItemPriceRegistDialog.vue?vue&type=template&id=515089cc&scoped=true&"
import script from "./ItemPriceRegistDialog.vue?vue&type=script&lang=js&"
export * from "./ItemPriceRegistDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515089cc",
  null
  
)

export default component.exports